export enum ConnectionType {
  MarketData = 'MarketData',
  Orders = 'Orders',
  RFQ = 'RFQ',
  Balances = 'Balances',
  Transfers = 'Transfers',
}
